import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, Clock, Video, Check } from "lucide-react";

export default function Meeting() {
  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [booked, setBooked] = useState(false);

  const days = Array.from({ length: 14 }).map((_, i) => {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    return d;
  });
  const slots = ["9:00 am", "9:30 am", "10:00 am", "10:30 am", "11:00 am", "1:00 pm", "2:00 pm", "3:30 pm", "4:00 pm"];

  if (booked) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-24 text-center">
        <div className="w-16 h-16 rounded-full mx-auto flex items-center justify-center" style={{ background: "#e8faef", color: "#16a34a" }}><Check size={28}/></div>
        <h1 className="mt-6 text-4xl font-extrabold">You're booked!</h1>
        <p className="mt-3 text-[#4b5566]">A calendar invite has been sent. We'll see you on {selectedDate?.toDateString()} at {selectedTime}.</p>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-6 py-14">
      <div className="grid md:grid-cols-3 gap-8">
        <div className="card-soft p-8 md:col-span-1">
          <Link to="/" className="inline-block">
            <img
              src="/images/somm-logo.png"
              alt="Somm.ai"
              className="h-12 w-auto object-contain"
            />
          </Link>
          <div className="text-sm text-[#7a8499] mt-6">Somm.ai</div>
          <h1 className="text-3xl font-extrabold mt-1">Book a Call</h1>
          <div className="mt-6 space-y-3 text-sm text-[#4b5566]">
            <div className="flex items-center gap-2"><Clock size={16}/> 30 min</div>
            <div className="flex items-center gap-2"><Video size={16}/> Web conferencing details provided upon confirmation</div>
            <div className="flex items-center gap-2"><Calendar size={16}/> America / New York</div>
          </div>
          <p className="mt-6 text-sm text-[#4b5566]">Learn how somm.ai can help you grow your on-premise business with the world's largest wine &amp; spirits list database.</p>
        </div>

        <div className="card-soft p-8 md:col-span-2">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <div className="font-semibold mb-4">Select a Date</div>
              <div className="grid grid-cols-7 gap-2">
                {days.map((d, i) => {
                  const isSel = selectedDate && d.toDateString() === selectedDate.toDateString();
                  const weekend = d.getDay() === 0 || d.getDay() === 6;
                  return (
                    <button
                      key={i}
                      disabled={weekend}
                      onClick={() => { setSelectedDate(d); setSelectedTime(null); }}
                      className={`aspect-square rounded-lg text-sm font-semibold transition-colors ${isSel ? "bg-[#22c55e] text-white" : weekend ? "bg-[#f6f8fb] text-[#c9cfda] cursor-not-allowed" : "bg-[#f6f8fb] hover:bg-[#eaf1ff] text-[#0b1526]"}`}
                    >
                      <div className="text-[10px] uppercase opacity-70">{d.toLocaleDateString("en", { weekday: "short" })}</div>
                      <div>{d.getDate()}</div>
                    </button>
                  );
                })}
              </div>
            </div>
            <div>
              <div className="font-semibold mb-4">{selectedDate ? selectedDate.toDateString() : "Select a time"}</div>
              <div className="grid grid-cols-2 gap-3 max-h-96 overflow-auto pr-1">
                {slots.map((s) => (
                  <button
                    key={s}
                    disabled={!selectedDate}
                    onClick={() => setSelectedTime(s)}
                    className={`py-3 rounded-lg font-semibold text-sm transition-colors ${selectedTime === s ? "bg-[#0b1526] text-white" : "border border-[#eef1f6] hover:border-[#22c55e] hover:text-[#22c55e]"} ${!selectedDate ? "opacity-50 cursor-not-allowed" : ""}`}
                  >{s}</button>
                ))}
              </div>
              <button
                disabled={!selectedDate || !selectedTime}
                onClick={() => setBooked(true)}
                className={`btn-green w-full justify-center mt-6 ${(!selectedDate || !selectedTime) ? "opacity-60 cursor-not-allowed" : ""}`}
              >Confirm booking</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
